import { useTranslation } from 'react-i18next';
import Popup from '../Atoms/Popup';
import React, { useState, useEffect } from 'react';
import H2 from '../Atoms/H2';
import Input from '../Atoms/Input';
import Select from '../Atoms/Select';
import Spinner from '../../Plateforme/Atoms/Spinner';
import * as api from '../../api';
import { useNavigate } from 'react-router-dom';
import { CountrySelectOptions, profilsNonVIA, profilsVIA } from '../Utils/Listings';
import ImageUpload from '../Atoms/ImageUpload';
import BlueButton from '../Atoms/BlueButton';
import Section from '../Atoms/Section';
import styled from 'styled-components';
import BigH1 from '../Atoms/BigH1';
import { validateFrom } from '../Utils/Validator';
import UploadProgressBar from '../Atoms/UploadProgressBar';
import { getRedirectFromParams, storeRedirect } from '../Utils/redirectUtils';

const ChampsAdhérentContainer = styled.div`
    border-bottom: 1px solid #ccc;
    padding: 10px 0 20px;

    .value {
        text-align: right;
        cursor: pointer;

        > span {
            display: inline-flex;
            align-items: center;
            justify-content: space-between;
            font-size: 12px;
            width: 90px;

            img {
                width: 35px;
                margin: 0 0 0 10px;
            }
        }
    }
`;

const Register = (props) => {

    const { i18n } = useTranslation('common');
    const [profileType, setProfileType] = useState("");
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [codifab , setCodifab] = useState("");
    const [ameublementfrancais , setAmeublementfrancais] = useState("");
    const [premiumPartner , setPremiumPartner] = useState("");
    const [hsData, setHsData] = useState({});
    const [uploadProgress, setUploadProgress] = React.useState(0);

    const urlParams = new URLSearchParams(window.location.search);
    const e = urlParams.get('e');
    const email = atob(e);
    const companyHubspotIdFromInvite = urlParams.get('c');
    // console.log("decoded email : "+email);
    
    // Check for redirect parameter and store it
    useEffect(() => {
        const redirectUrl = getRedirectFromParams(urlParams);
        if (redirectUrl) {
            storeRedirect(redirectUrl);
        }
    }, []);

    async function handleRegister(event) {
        event.preventDefault();
        // console.log("registering")
        const submission = new FormData(event.target);
        if(!validateFrom(submission)) return;
        if(profileType === "via"){
            if(!event.target.elements.profilepicture?.files[0]){
                alert(i18n.language === "fr" ? "Veuillez ajouter une photo de profil" : "Please add a profile picture");
                return
            }
        }
        setLoading(true);
        const registrationRequest = new FormData();
        registrationRequest.append("email", email);
        registrationRequest.append("language", i18n.language);
        // registrationRequest.append("civilit_", event.target.elements.civility?.value);
        registrationRequest.append("firstname", event.target.elements.firstname?.value);
        registrationRequest.append("lastname", event.target.elements.lastname?.value);
        registrationRequest.append("jobtitle", event.target.elements.currentposition?.value);
        registrationRequest.append("city", event.target.elements.city?.value);
        registrationRequest.append("country", event.target.elements.country?.value);
        registrationRequest.append("password", event.target.elements.password?.value);
        registrationRequest.append("cat_gories_via", event.target.elements.profile?.value);
        registrationRequest.append("profilepicture", event.target.elements.profilepicture?.files[0]);
        registrationRequest.append("portraitCredit", event.target.elements.creditphoto?.value);
        registrationRequest.append("codifab", codifab);
        registrationRequest.append("ameublementfrancais", ameublementfrancais);
        registrationRequest.append("premiumPartner", premiumPartner);
        registrationRequest.append("companyHubspotIdFromInvite", companyHubspotIdFromInvite);

        function onUploadProgress(progressEvent){
            const percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
            setUploadProgress(percentCompleted);
        }
        
        api.Register(registrationRequest, onUploadProgress).then((response) => {
            // console.log(response.data)
            if(response.data === "email already registered"){
                alert(i18n.language === "fr" ? "Vous êtes déja inscrit sur la plateforme, veuillez vous connecter." : "You are already registered on the platform, please login.");
                //navigate to login
                navigate('/login');
            }
            api.Login({email, password : event.target.elements.password?.value}).then(res => {
                // console.log(res);
                if (res.data.status === "OK") {
                    props.refreshUser();
                    //navigate to my profile
                    navigate('/myprofile');
                }
            }).catch(function (error) {
                console.log(error);
                if (error.response && error.response.data === "incorrect credentials") {
                    console.log("incorrect credentials");
                }
            });
            setLoading(false);
        });
    }

    React.useEffect(() => {
        // check email isnt yet registered
        api.CheckExistingUser({email}).then((response) => {
            // console.log(response.data)
            if(response.data === "email already registered"){
                alert(i18n.language === "fr" ? "Vous êtes déja inscrit sur la plateforme, veuillez vous connecter." : "You are already registered on the platform, please login.");
                //navigate to login
                navigate('/login');
            }
        });
    },[email]);

    React.useEffect(() => {
        setLoading(true)
        // get existing hubspot information
        api.GetAllUserData({email}).then((response) => {
            // console.log(response.data)
            if(response.data.hsProfile?.cat_gories_via){
                if(profilsVIA.includes(response.data.hsProfile.cat_gories_via)){
                    setProfileType("via")
                    if(response.data.hsProfile.adherent?.includes("CODIFAB")){
                        setCodifab("Oui")
                    }
                    if(response.data.hsProfile.adherent?.includes("Ameublement Français")){
                        setAmeublementfrancais("Oui")
                    }
                }
                else if(profilsNonVIA.includes(response.data.hsProfile?.cat_gories_via)){
                    setProfileType("nonvia")
                }
                else{
                    response.data.hsProfile.cat_gories_via = ""
                }
            }
            setHsData(response.data.hsProfile)
            setLoading(false)
        }).catch((error) => {
            console.log(error);
            setLoading(false)
        });
    }, [email])

    // const civilitéDefaultValue = () => {
    //     if(hsData.civilit_ === "Monsieur" || hsData.civilit_ === "Cher"){
    //         return "Monsieur"
    //     } else if(hsData.civilit_ === "Madame" || hsData.civilit_ === "Chère"){
    //         return "Madame"
    //     } else {
    //         return "Autre"
    //     }
    // }

    // const adhérentDepuisMoinsDunAn = () => {
    //     if(!hsData.date_adhesion_club_le_french_design){
    //         return false
    //     }
    //     //compare date in format YYYY-MM-DD to date 1 year ago
    //     const date1YearAgo = new Date(new Date().setFullYear(new Date().getFullYear() - 1)).toISOString().split('T')[0]
    //     return hsData.date_adhesion_club_le_french_design.localeCompare(date1YearAgo) > 0
    // }

    function toggle(value){
        if(value === "Oui"){
            return "Non"
        } else {
            return "Oui"
        }
    }

    return (
        <div>
            <Section className="padding">
                <BigH1>{i18n.language === "fr" ? "INSCRIPTION À" : "REGISTER TO"}<br/>{i18n.language === "fr" ? "LA COMMUNAUTÉ" : "THE COMMUNITY"}</BigH1><br/>
                <img src="/img/LogosV3.png" style={{width:"250px"}} alt="Le French Design"/>
            </Section>
            {!profileType && !loading ?
                <Popup>
                    <H2>{i18n.language === "fr" ? "Vous êtes ?" : "You are?"}</H2><br/>
                    <div style={{display:"flex", flexDirection:"row", justifyContent:"space-between", width:"100%", gap:'20px'}}>
                        <BlueButton onClick={() => { setProfileType("via")}}>{i18n.language === "fr" ? "Créateur / Designer / Architecte / Editeur / Fabricant" : "Creator / Designer / Architect / Editor / Manufacturer"}</BlueButton>
                        <BlueButton onClick={() => { setProfileType("nonvia")}}>{i18n.language === "fr" ? "Autre" : "Other"}</BlueButton>
                    </div>
                </Popup>
            :
                <>
                    {loading ?
                        <>
                            <br/><br/><br/><br/><Spinner/><br/>
                            <UploadProgressBar uploadProgress={uploadProgress}/>
                        </>
                    :
                        <form onSubmit={event => handleRegister(event)}>
                            <Section className="padding">
                                <div className='flexblock' style={{alignItems:"flex-start"}}>
                                    <div>
                                        {/* <span>{i18n.language === "fr" ? "Civilité" : "Civility"}</span><br/>
                                        <Select name="civility" placeholder={i18n.language === "fr" ? "Civilité" : "Civility"} style={{width:"100%"}} defaultValue={civilitéDefaultValue()}>
                                            <option value="Madame">{i18n.language === "fr" ? "Femme" : "Woman"}</option>
                                            <option value="Monsieur">{i18n.language === "fr" ? "Homme" : "Man"}</option>
                                            <option value="Autre">{i18n.language === "fr" ? "Ne souhaite pas répondre" : "Prefer not to answer"}</option>
                                        </Select><br/><br/> */}
                                        <Input name="firstname" style={{width:"100%"}} required placeholder={i18n.language === "fr" ? "Prénom" : "Nom"} defaultValue={hsData.firstname}/><br/><br/>
                                        <Input name="lastname" style={{width:"100%"}} required placeholder={i18n.language === "fr" ? "Nom" : "Last name"} defaultValue={hsData.lastname}/><br/><br/>
                                        <Input name="city" style={{width:"100%"}} required placeholder={i18n.language === "fr" ? "Ville" : "City"} defaultValue={hsData.city}/><br/><br/>
                                        <div className='flexblock'>
                                            <span>{i18n.language === "fr" ? "Pays" : "Country"}</span>
                                            <Select name="country" placeholder={i18n.language === "fr" ? "Pays" : "Country"}  style={{width:"100%"}} defaultValue={hsData.country}>
                                                <CountrySelectOptions/>
                                            </Select>
                                        </div>
                                        <div className='flexblock'>
                                            <span>{i18n.language === "fr" ? "Votre profil" : "Your profile"}</span>
                                            <Select name="profile" placeholder={i18n.language === "fr" ? "Votre profil" : "Your profile"} style={{width:"100%"}} defaultValue={hsData.cat_gories_via}>
                                                {profileType === "via" ?
                                                <>
                                                    <option value="Donneur d'ordre">{i18n.language === "fr" ? "Donneur d'ordre /prescripteur" : "Client / prescriber"}</option>
                                                    <option value="Créateur - Architecte">{i18n.language === "fr" ? "Architecte" : "Architect"}</option>
                                                    <option value="Créateur - Designer objet">{i18n.language === "fr" ? "Designer objet" : "Object designer"}</option>
                                                    <option value="Créateur - Designer espace">{i18n.language === "fr" ? "Architecte d'intérieur" : "Interior designer"}</option>
                                                    <option value="Créateur - Graphiste">{i18n.language === "fr" ? "Graphiste" : "Graphic designer"}</option>
                                                    <option value="Créateur - Scénographe">{i18n.language === "fr" ? "Scénographe" : "Set designer"}</option>
                                                    <option value="Créateur - Stratégie de marque">{i18n.language === "fr" ? "Créateur Stratégie de marque" : "Brand strategy designer"}</option>
                                                    <option value="Créateur - Stratégie digitale">{i18n.language === "fr" ? "Créateur Stratégie digitale" : "Digital strategy designer"}</option>
                                                    <option value="Producteur -  Galerie">{i18n.language === "fr" ? "Galeriste" : "Gallery"}</option>
                                                    <option value="Producteur - Equipementier / Matériaux">{i18n.language === "fr" ? "Équipementier / matériaux" : "Equipment / materials"}</option>
                                                    <option value="Producteur - Agenceur">{i18n.language === "fr" ? "Agenceur" : "Fitter"}</option>
                                                    <option value="Producteur - Artisan d'art">{i18n.language === "fr" ? "Artisan d'art" : "Craftsman"}</option>
                                                    <option value="Producteur - Editeur">{i18n.language === "fr" ? "Éditeur" : "Editor"}</option>
                                                    <option value="Producteur - Fabricant">{i18n.language === "fr" ? "Fabricant" : "Manufacturer"}</option>
                                                    <option value="Producteur - Distributeur">{i18n.language === "fr" ? "Distributeur" : "Distributor"}</option>
                                                    <option value="Producteur - Autres">{i18n.language === "fr" ? "Autre" : "Other"}</option>
                                                </>
                                                :
                                                <>
                                                    <option value="Presse">{i18n.language === "fr" ? "Presse" : "Press"}</option>
                                                    <option value="Institutionnel">{i18n.language === "fr" ? "Institutionnel" : "Institutional"}</option>
                                                    <option value="Institutionnel - Ecole">{i18n.language === "fr" ? "Institutionnel - école" : "Institutional - school"}</option>
                                                    <option value="Institutionnel - Consulat / ambassade">{i18n.language === "fr" ? "Institutionnel - consulat / ambassade" : "Institutional - consulate / embassy"}</option>
                                                    <option value="Institutionnel - Musée / centre d'art">{i18n.language === "fr" ? "Institutionnel - musée / centre d'art" : "Institutional - museum / art center"}</option>
                                                    <option value="Institutionnel - Salon / foire">{i18n.language === "fr" ? "Institutionnel - salon / foire" : "Institutional - trade show / fair"}</option>
                                                    <option value="Autres">{i18n.language === "fr" ? "Autre" : "Other"}</option>
                                                </>
                                                }
                                            </Select>
                                        </div>
                                        {profileType === "nonvia" && <>
                                            <br/>
                                            <ChampsAdhérentContainer className="flexblock">
                                                <span>{i18n.language === "fr" ? "Partenaire Premium Connected By" : "Premium partner connected by"}</span>
                                                <span className="value" onClick={() => setPremiumPartner(toggle(premiumPartner))}>{premiumPartner === "Oui" ? <span>{i18n.language === "fr" ? "Oui" : "Yes"}<img src="/img/toggle_on.png"/></span> : <span>{i18n.language === "fr" ? "Non" : "No"}<img src="/img/toggle_off.png"/></span>}</span>
                                            </ChampsAdhérentContainer>
                                        </>}
                                        <Input name="currentposition" style={{width:"100%"}} required placeholder={i18n.language === "fr" ? "Poste actuel" : "Current position"}  defaultValue={hsData.jobtitle}/><br/><br/>
                                        <Input name="password" style={{width:"100%"}} required placeholder={i18n.language === "fr" ? "Mot de passe" : "Password"} type="password" minLength={6}/><br/><br/>
                                        <br/>
                                        {profileType === "via" && <>
                                            <span className='centered'>{i18n.language === "fr" ? "Qui peut consulter mon profil ?" : "Who can view my profile ?"}</span><br/>
                                            <span className='centered' style={{fontWeight:"300"}}>{i18n.language === "fr" ? "Mon profil est visible par les membres de la communauté et les partenaires Le French Design." : "My profile is visible to community members and Le French Design partners."} {i18n.language === "fr" ? "En vous inscrivant, vous acceptez que votre profil soit visible par la communauté." : "By registering, you agree that your profile will be visible to the community."}</span><br/>
                                            <br/>
                                            {/* <ChampsAdhérentContainer className="flexblock">
                                                <span>{i18n.language === "fr" ? "Cotisant CODIFAB" : "CODIFAB member"}</span>
                                                <span className="value" onClick={() => setCodifab(toggle(codifab))}>{codifab === "Oui" ? <span>{i18n.language === "fr" ? "Oui" : "Yes"}<img src="/img/toggle_on.png"/></span> : <span>{i18n.language === "fr" ? "Non" : "No"}<img src="/img/toggle_off.png"/></span>}</span>
                                            </ChampsAdhérentContainer>
                                            {codifab === "Oui" && <div style={{fontSize:"12px",marginTop:"10px"}}>{i18n.language === "fr" ? "En tant que cotisant, l'adhésion à la plateforme vous est offert" : "As a member, membership to the platform is offered to you"}</div>}
                                            <br/><br/>
                                            <ChampsAdhérentContainer className="flexblock">
                                                <span>{i18n.language === "fr" ? "Adhérent Ameublement Français" : "Ameublement Français member"}</span>
                                                <span className="value" onClick={() => setAmeublementfrancais(toggle(ameublementfrancais))}>{ameublementfrancais === "Oui" ? <span>{i18n.language === "fr" ? "Oui" : "Yes"}<img src="/img/toggle_on.png"/></span> : <span>{i18n.language === "fr" ? "Non" : "No"}<img src="/img/toggle_off.png"/></span>}</span>
                                            </ChampsAdhérentContainer>
                                            {ameublementfrancais === "Oui" && <div style={{fontSize:"12px",marginTop:"10px"}}>{i18n.language === "fr" ? "En tant que cotisant, l'adhésion à la plateforme vous est offert" : "As a member, membership to the platform is offered to you"}</div>}
                                            <br/><br/> */}
                                            <p class="red">{i18n.language === "fr" ? "L’inscription est gratuite pour les cotisants CODIFAB et adhérents de l’Ameublement français." : "Registration is free for CODIFAB members and Ameublement français members."}</p>
                                            <br/><br/>
                                             <p class="red">
                                             {i18n.language === "fr" ? "Si vous êtes dans l’un de ces cas, merci d’adresser un email à" : "If you are in one of these cases, please send an email to"} <a href="mailto:connectedby@via.fr">connectedby@via.fr</a> {i18n.language === "fr" ? "avant de procéder à votre inscription : vous recevrez un lien spécifique dans les plus brefs délais." : "before proceeding with your registration: you will receive a specific link as soon as possible."}</p>
                                        </>}<br/><br/>
                                        {/* {(profileType === "via" && (codifab === "Oui" || ameublementfrancais === "Oui")) || adhérentDepuisMoinsDunAn() ? <>
                                            Placeholder texte exemption paiement
                                        </>:<>
                                            Placeholder texte paiement
                                        </>} */}
                                    </div>
                                    <div>
                                        <ImageUpload
                                            textFR="une photo de profil"
                                            textEN="a profile picture"
                                            name="profilepicture"
                                            creditFieldName="creditphoto"
                                            required={profileType === "via"}
                                            width="400px"
                                            height="400px"
                                        /><br/>
                                    </div>
                                </div>
                                <Input type="checkbox" required/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>{i18n.language === "fr" ? "J'ai lu et j'accepte" : "I have read and accept"}</span> <a href='/documents/cvg-cgu.pdf' target='_blank' rel="noreferrer">{i18n.language === "fr" ? "les conditions générales de vente." : "the terms and conditions of sale."}</a><br/><br/><br/>
                            </Section>
                            <Section className="padding">
                                <BlueButton className="centered" style={{width:'100%'}}><img src='/img/fleche_blanche.png' alt='' />{i18n.language === "fr" ? "Créer mon compte" : "Create my account"}</BlueButton>
                            </Section>
                            <br/><br/>
                            <br/><br/>
                        </form>
                    }
                </>
            }
        </div>
    );
};

export default Register;